import './Certificate.css';

const Certificate = () => {
    return (
        <section className="certificate">
                <div className="left educationBg"></div>
                <div className="right">
                    <span>СЕРТИФІКАТ ВІД ГАРВАРДУ</span>
                    <p>
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type.  
                    </p>
                    <button>ОТРИМАТИ!</button>
                </div>
            </section>
    )
}

export default Certificate;